export default class Locale_ScheduleJob {
	PluginId: string = "Plugin id";
	PluginName: string = "Plugin name";
	CronExpression: string = "Cron expression (Timezone is UTC)";
	CronExpressionValidation: string = "Cron expression is malformed!";
	LastOccurrence: string = "Last occurrence";
	NextOccurence: string = "Next occurrence";
	Body: string = "Body";
	LastRuns: string = "Last 10 runs";
}